import { Switch, message } from "antd"
import { translations } from "../../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const { common_error_msg } = translations[lang]

const hasBusinessOrStore = (row = {}) =>
  Boolean(
    row?.business_id ||
      row?.store_id ||
      row?.business?.id ||
      row?.store?.id ||
      row?.business_name ||
      row?.store_name
  )

export const actions = (
  handleViewUserDetails,
  handleUpdateUserStatus,
  showUpdateRoleModal,
  updateLoading,
  handleDeleteMerchantModalOpen,
  canDelete = true // false for `edit_only` roles: everything but delete
) => [
  {
    button: (row) =>
      hasBusinessOrStore(row) ? (
        <button type="button" className="custom-view-btn">
          <span>View</span>
          <img src="/dashboard/vector-up.svg" alt="" />
        </button>
      ) : (
        <span className="custom-view-placeholder">-</span>
      ),
    onClick: (row) => {
      if (hasBusinessOrStore(row)) handleViewUserDetails(row)
    },
    type: "button",
  },
  {
    switch: (row) => (
      <>
        <Switch
          checked={
            row.status === true ||
            String(row.status ?? "").toLowerCase() === "active"
          }
          className="custom-switch mr-20"
          disabled={updateLoading[row.id]}
          onChange={(status) => {
            if (!updateLoading[row.id]) {
              handleUpdateUserStatus(row, status)
              message.warning(common_error_msg?.wait_while_product_uploading)
            }
          }}
        />
      </>
    ),
    // onClick: (row) => handleUpdateUserStatus(row),
    type: "switch",
  },
  {
    icon: "/store/editStore.svg",
    className: "edit",
    onClick: (row) => showUpdateRoleModal(row),
    type: "image",
  },
  ...(canDelete
    ? [
        {
          icon: "/store/trash.svg",
          className: "delete",
          onClick: (row) => handleDeleteMerchantModalOpen(row),
          type: "image",
        },
      ]
    : []),
]

export const readOnlyActions = (handleViewUserDetails) => [
  {
    button: (row) =>
      hasBusinessOrStore(row) ? (
        <button type="button" className="custom-view-btn">
          <span>View</span>
          <img src="/dashboard/vector-up.svg" alt="" />
        </button>
      ) : (
        <span className="custom-view-placeholder">-</span>
      ),
    onClick: (row) => {
      if (hasBusinessOrStore(row)) handleViewUserDetails(row)
    },
    type: "button",
  },
]
